import React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { GET_PERSONALITIES } from '../graphql/index';
import { changePersonalitiesFilter } from '../actions/index';
// Components
import LoadingContent from '../components/layout/loadingContent/LoadingContent';
import PersonalitiesList from '../components/screens/personalities/PersonalitiesList';


const withData = graphql(GET_PERSONALITIES, {
  options: (
    { locale, filter }) => ({ variables: { language: locale, filter } }
  ),
  // eslint-disable-next-line no-unused-vars
  props: ({ ownProps, data }) => {
    const { loading, personalities } = data;
    return { loading, personalities };
  },
});

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
    filter: state.personalitiesFilterSelector,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterSubmit: (newFilter) => {
      dispatch(changePersonalitiesFilter(newFilter));
    },
  };
};

const withLoader = (props) => {
  const result = props.loading // eslint-disable-line react/prop-types
  ? <LoadingContent />
  : <PersonalitiesList {...props} />;

  return <span>{result}</span>;
};


const ContainerWithData = withData(withLoader);
const PersonalitiesContainer = connect(mapStateToProps, mapDispatchToProps)(ContainerWithData);

export default PersonalitiesContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/PersonalitiesContainer.js
 **/